import app from "./app";

const auth = app.auth();

if (import.meta.env.VITE_USE_EMULATOR) {
	auth.useEmulator("http://localhost:9099");
}

export default auth;
